import { getPreparedTags } from './index';
/**
 * Extracts end user converstation message content
 *
 * @param messages Dixa conversation messages
 */
export function extractConversationTextFromMessages(messages) {
    const userMessages = messages.reduce((prev, msg) => {
        if (!!msg.text && msg.direction === 'inbound') {
            return prev.concat(`${msg.text}\n\n`);
        }
        return prev;
    }, '');
    return userMessages;
}
/**
 * Merge conversation subject with conversation text in format required to send
 * to grappa api
 */
export function mergeConversationTextWithSubject({ conversationSubject, conversationText, }) {
    if (!conversationSubject)
        return conversationText;
    return `${conversationSubject}\n\n${conversationText}`;
}
/**
 * Extracts tag names from tags
 *
 * @param tags Dixa conversation tags
 */
export function extractTagNames(tags) {
    return (tags === null || tags === void 0 ? void 0 : tags.map((t) => t.name)) || [];
}
/**
 * Extracts end user converstation message content
 *
 * @param messages Dixa conversation messages
 */
export function convertMessagesToParsedMessages(messages) {
    const initialMessages = [];
    const parsedMessages = messages.reduce((prev, msg) => {
        if (!!msg.text &&
            msg.direction === 'inbound' &&
            msg.created_at &&
            msg.channel) {
            const parsedMessage = {
                message: msg.text,
                sender_type: 'user',
                timestamp: new Date(msg.created_at).toISOString(),
                type: msg.channel,
            };
            prev.push(parsedMessage);
        }
        return prev;
    }, initialMessages);
    return parsedMessages;
}
export function getTruncatedMessage(message, threshold = 4997) {
    // Cater for null message
    if (!message)
        return '';
    // Indicate that message has been truncated with ...
    // Threshold is not always 4997 as sometimes the attachment html length needs to be accounted for
    return message.length > 5000 ? message.slice(0, threshold) + '...' : message;
}
export function transformMessagesToConversationThread(messages) {
    const thread = messages.reduce((acc, conversationMessage) => {
        const { text, created_at, direction, type } = conversationMessage;
        if (!text ||
            !created_at ||
            type === 'conversation:wrapup_message' || // internal note
            type === 'conversation:wrapup_added' // internal note
        )
            return acc;
        const thread = {
            message: getTruncatedMessage(text),
            timestamp: created_at,
            sender_type: direction === 'outbound' ? 'agent' : 'user',
        };
        return acc.concat(thread);
    }, []);
    return thread;
}
export function getDraftTicketThread({ url: ticketLink, tagNames, notes, articleContent, }) {
    const date = new Date();
    const preparedTags = getPreparedTags(tagNames);
    const ticketLinkMessage = {
        message: `<blockquote class="elevio-box-info"><b>Ticket Link:</b><br/><a href="${ticketLink}" target="_blank">${ticketLink}</a></blockquote>`,
        timestamp: date.toISOString(),
        sender_type: 'custom',
    };
    const tagsMessage = {
        message: `<blockquote class="elevio-box-info"><b>Tags:</b><br/>${preparedTags}</blockquote>`,
        timestamp: date.toISOString(),
        sender_type: 'custom',
    };
    const customNoteMessage = {
        message: `<blockquote class="elevio-box-info"><b>Notes:</b><br/>${notes}<br/></blockquote>`,
        timestamp: date.toISOString(),
        sender_type: 'custom',
    };
    const draftTicketThread = composeThreadFromArticleContent({
        articleContent,
    });
    const ticketThreadWithCustomMessages = [
        ticketLinkMessage,
        tagsMessage,
        customNoteMessage,
        draftTicketThread,
    ];
    return ticketThreadWithCustomMessages;
}
/** Composes html string from messages */
export function composeArticleContentFromMessages(messages) {
    const htmlString = messages.reduce((prev, currentMessage) => {
        const { type, text, direction } = currentMessage;
        if (!text || // discard any blank messages
            type === 'conversation:wrapup_message' // don't include internal notes
        ) {
            return prev;
        }
        const user = direction === 'inbound' ? 'User' : 'Agent';
        return prev.concat(`<b>${user} wrote:</b><br/>${text}<br/><hr/>`);
    }, '');
    return htmlString;
}
function composeThreadFromArticleContent({ articleContent, }) {
    const thread = {
        message: articleContent,
        timestamp: new Date().toISOString(),
        sender_type: 'agent',
    };
    return thread;
}
